import { connect } from 'react-redux'
import ClinicView from '../components/ClinicView'
import { getOrganizations, createOrganization } from '../../../store/organizations'
import { getSites, createSite, associateDeviceWithSite, dissociateDeviceWithSite, updateSite } from '../../../store/sites'
import { getPatients, updatePatientBrand, updatePatient, createPatient } from '../../../store/patients'
import { getPrescriber, getPrescribers, createPrescriber, addPrescriberToSite, uploadSignature, updatePrescriberAndUploadSignature, updateSalesPerson } from '../../../store/prescribers'
import { getDevices, associateDeviceWithUser, dissociateDeviceWithUser } from '../../../store/devices'
import { getPharmacies } from '../../../store/pharmacies'
import { getUsers, createUser, resetPassword } from '../../../store/user'

const mapDispatchToProps = {
  getOrganizations,
  getUsers,
  getPrescriber,
  getPrescribers,
  updateSalesPerson,
  getSites,
  getDevices,
  getPharmacies,
  createPatient,
  getPatients,
  createOrganization,
  createUser,
  createSite,
  createPrescriber,
  updatePrescriberAndUploadSignature,
  associateDeviceWithUser,
  dissociateDeviceWithUser,
  associateDeviceWithSite,
  dissociateDeviceWithSite,
  addPrescriberToSite,
  uploadSignature,
  resetPassword,
  updatePatientBrand,
  updatePatient,
  updateSite
}

const mapStateToProps = (state) => {
  return {
    organizations: state.organizations.organizations,
    prescribers: state.prescribers.prescribers,
    sites: state.sites.sites,
    patients: state.patients,
    devices: state.devices.devices,
    pharmacies: state.pharmacies.pharmacies,
    users: state.user.users,
    ui: state.ui,
    createdOrganization: state.organizations.createdOrganization,
    createdSite: state.sites.createdSite,
    createdPrescriber: state.prescribers.createdPrescriber,
    updatedPrescriber: state.prescribers.updatedPrescriber,
    uploadedSignature: state.prescribers.uploadedSignature,
    createdUser: state.user.createdUser,
    updatedUser: state.user.updatedUser,
    passwordReset: state.user.passwordReset,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClinicView)



// WEBPACK FOOTER //
// ./src/routes/Clinic/containers/ClinicContainer.jsx